import { url } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class GetAvailableDeliveryDay {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * GetAvailableDeliveryDay constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Get the delivery day name via API for requested postcode.
     *
     * @param {String} postcode
     *
     * @returns {Promise}
     */
    handle(postcode) {
        let apiUrl = url(ApiEndpoints['postcodes.delivery-day'], [postcode]);

        return this.apiService.get(apiUrl);
    }
}
